import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { Navigate } from 'react-router-dom';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const AdminUsers = Loadable(lazy(() => import('pages/users-management')));
const AdminUserDetail = Loadable(lazy(() => import('pages/user-detail')));
const SubscriptionPlans = Loadable(lazy(() => import('pages/subscription-plans')));

// ==============================|| MAIN ROUTING ||============================== //
const AdminGuard = () => {
  const isAuthenticated = !!localStorage.getItem('admin_user');
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }
  return <DashboardLayout />;
};

const MainRoutes = {
  path: '/',
  element: <AdminGuard />,
  children: [
    {
      index: true,
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'users',
      element: <AdminUsers />
    },
    {
      path: 'users/:id',
      element: <AdminUserDetail />
    },
    {
      path: 'subscriptions',
      element: <SubscriptionPlans />
    },
  ]
};

export default MainRoutes;
